// extracted by mini-css-extract-plugin
export var linkText = "_ng-0";